import {apiSlice} from './apiSlice';

/**
 * Dịch vụ bên thứ 3 — hạn mức & ngân sách (admin, features/Member/ServiceQuotas).
 * GET tổng hợp sử dụng theo tháng + chuẩn đoán tiền; PUT lưu số dư đầu kỳ từng tài khoản.
 */
export const serviceQuotaApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getServiceQuotas: builder.query({
			query: (params = {}) => ({url: 'admin/service-quotas', method: 'get', params}),
			transformResponse: (body) => body?.data || null,
			providesTags: ['ServiceQuota'],
		}),
		updateServiceBudgets: builder.mutation({
			query: (data) => ({url: 'admin/service-quotas/budgets', method: 'put', data}),
			invalidatesTags: ['ServiceQuota'],
		}),
	}),
});

export const {useGetServiceQuotasQuery, useUpdateServiceBudgetsMutation} = serviceQuotaApiSlice;
